<template>
    <div class="deleteWindow">
        <div class="deleteModal">
            <div class="contentEdit2 md-elevation-10">
                <div class="md-layout-item" v-if="!branding">
                    <p>{{ options.Lang.delete_Angebotsgruppe }}</p>
                    <div class="buttonContainer">
                        <md-button class="md-primary md-raised" @click="deleteGroup"><strong>löschen</strong></md-button> 
                        <md-button class="secondary md-raised" @click="cancelDelete"><strong>Fenster schließen</strong></md-button>
                    </div>
                </div>
                <div class="md-layout-item" v-if="branding">
                    <p>Branding löschen</p>

                    <div v-if="allBrands.length <= 1">
                        <p>Branding kann nicht gelöscht werden. Erstellen Sie mindestens ein weiteres Branding.</p>

                        <div class="buttonContainer">
                            <md-button class="secondary md-raised" @click="cancelDelete"><strong>Fenster schließen</strong></md-button>
                        </div>
                    </div>

                    <div v-if="allBrands.length > 1">
                        <p>Bitte wählen Sie ein neues Branding für die betroffenen Trips vom Branding welches Sie löschen möchten.</p>
                        <br>
                        <md-field>
                            <br>
                            <label for="sprache">Branding</label>
                            <md-select tabindex="3" name="sprache" id="sprache"  v-model="ersatzBrand" md-dense>
                                <md-option v-for="(brand, index) in allBrands" v-if="brand.id != id" :key="'brand'+index" :value="brand.id">{{brand.adresse}}</md-option>
                            </md-select>
                        </md-field>

                        <div class="buttonContainer">
                            <md-button class="md-primary md-raised" id="uploadButton" disabled @click="deleteGroup"><strong>löschen</strong></md-button> 
                            <md-button class="secondary md-raised" @click="cancelDelete"><strong>Fenster schließen</strong></md-button>
                        </div>
                    </div>

                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        booleanProp: {
            type: Boolean
        },
        id: {
           type: Number, 
        },
        options: {
            type: Object,
            required: true
        },
        branding:{
            type: Object
        },
        allBrands:{
            type: Array,
            default: () => []
        }
    },

	data() {
        return {
            ersatzBrand: null,
            showModal: this.data
        }

    },
    updated(){
            if(this.ersatzBrand == null || this.ersatzBrand == "" ||  this.ersatzBrand == "null"){
                let button = document.getElementById("uploadButton")
                button?.setAttribute("disabled", true)
                }else{
                let button = document.getElementById("uploadButton")
                button?.removeAttribute("disabled")
                }
        
    },
    methods: {
        cancelDelete() {
            this.$emit('update-boolean', !this.booleanProp);
        },
        test(id){
            alert(id)
        },
        async deleteGroup() {
            this.activeId = this.id;
            
            this.$emit('active-delete', this.activeId, this.ersatzBrand, !this.booleanProp);
        },

        abort() {
            window.setTimeout(function(){location.reload();}, 1000)
        },
    }
};
</script>

<style lang="scss" scoped>

.deleteWindow {
    width: 100%;
    // background-color: rgba(0, 0, 0, 0.75);
    
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 7;
}

.deleteModal {
    width: 700px;
    // height: 250px;
    border-radius: 1rem;
    // background-color: #F5F6FA;
    position: relative;
    margin-right: auto;
    margin-left: auto;
    top: 40%;

    .buttonContainer {
        float: right;
        margin-top: 25px;
    }

}

.contentEdit2{
  position: absolute;
  top: 35%;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: max-content !important;
  left: 5%;
}

</style>
